export const NOTIFICATION_MESSAGE = "NOTIFICATION_MESSAGE"
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
export const CREATE_LANDING_PAGE_PENDING = "CREATE_LANDING_PAGE_PENDING"
export const CREATE_LANDING_PAGE_SUCCESS = "CREATE_LANDING_PAGE_SUCCESS"